module.exports = __webpack_public_path__ + "static/media/3.6de77642.jpg";